import client from './client';

export const sensuApi = {
  async listNamespaces() {
    const { data } = await client.get('/api/admin/sensu/namespaces');
    return data;
  },

  async createNamespace(name) {
    const { data } = await client.post('/api/admin/sensu/namespaces', { name });
    return data;
  },

  async listEntities(namespace) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/entities`);
    return data;
  },

  async createEntity(namespace, entity) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/entities`, entity);
    return data;
  },

  async listEvents(namespace) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/events`);
    return data;
  },

  async getEvent(namespace, entity, check) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/events/${entity}/${check}`);
    return data;
  },

  async resolveEvent(namespace, entity, check) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/events/${entity}/${check}/resolve`);
    return data;
  },

  async listChecks(namespace) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/checks`);
    return data;
  },

  async getCheck(namespace, name) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/checks/${name}`);
    return data;
  },

  async createCheck(namespace, check) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/checks`, check);
    return data;
  },

  async updateCheck(namespace, name, check) {
    const { data } = await client.put(`/api/admin/sensu/namespaces/${namespace}/checks/${name}`, check);
    return data;
  },

  async executeCheck(namespace, name) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/checks/${name}/execute`);
    return data;
  },

  async deleteCheck(namespace, name) {
    const { data } = await client.delete(`/api/admin/sensu/namespaces/${namespace}/checks/${name}`);
    return data;
  },

  async listHandlers(namespace) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/handlers`);
    return data;
  },

  async createHandler(namespace, handler) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/handlers`, handler);
    return data;
  },

  async updateHandler(namespace, name, handler) {
    const { data } = await client.put(`/api/admin/sensu/namespaces/${namespace}/handlers/${name}`, handler);
    return data;
  },

  async deleteHandler(namespace, name) {
    const { data } = await client.delete(`/api/admin/sensu/namespaces/${namespace}/handlers/${name}`);
    return data;
  },

  async listSilenced(namespace) {
    const { data } = await client.get(`/api/admin/sensu/namespaces/${namespace}/silenced`);
    return data;
  },

  async createSilence(namespace, silence) {
    const { data } = await client.post(`/api/admin/sensu/namespaces/${namespace}/silenced`, silence);
    return data;
  },

  async deleteSilence(namespace, name) {
    const { data } = await client.delete(`/api/admin/sensu/namespaces/${namespace}/silenced/${name}`);
    return data;
  },
};
